import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiErrorHandler } from '../../../errors/api-error-handler';
import { RightSideTrailType, RightSideTrailInitialStateType } from "../../../models/right-side-trail-model";
import NewsArticlesRightSideLearningService from '../../../services/right-side/news-articles-right-side-learning.service';

const initialState: RightSideTrailInitialStateType = {
    rightSideFeaturedBooksData: [],
    rightSideFeaturedLearningData: [],
    rightSideTrendingNewsData: [],
    rightSidePopularEventsData: [],
    Loading: false,
    Error: undefined,
};


export const retrieveNewsArticlesRightSideLearning = createAsyncThunk('NewsArticlesRightSideLearning/retrieve',
    async (productPath: string, { rejectWithValue }) => {
        try {

            const response = await NewsArticlesRightSideLearningService.getNewsArticlesRightSideLearningService(productPath)
            return [response.data]

        } catch (error: any) {
            if (!error.response) {
                throw error
            }
            return rejectWithValue(error.response.status)
        }
    }
)

const NewsArticlesRightSideLearningSlice = createSlice({
    name: 'NewsArticlesRightSideLearning',
    initialState: initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(retrieveNewsArticlesRightSideLearning.pending, (state) => {
                state.Loading = true;
            })
            .addCase(retrieveNewsArticlesRightSideLearning.fulfilled, (state, action) => {
                if (action.payload) {
                    state.Loading = false;
                    state.rightSideFeaturedLearningData = action.payload as RightSideTrailType[];
                }
            })
            .addCase(retrieveNewsArticlesRightSideLearning.rejected, (state, { payload }) => {
                state.Loading = false;
                state.Error = apiErrorHandler(Number(payload))
            })
    }
})

export const selectAllEntities = (state: { entities: any; }) => state.entities;
export default NewsArticlesRightSideLearningSlice.reducer;
